export const nodesZh: Record<string, string> = {
  'action_0_0': '+5% 行动伤害提升',
  'action_0_1': '+5% 行动造成双倍伤害的概率',
  'action_0_2': '+12% 行动伤害提升',
  'action_0_3': '+5% 行动伤害提升',
  'action_0_4': '+5% 行动造成双倍伤害的概率',
  'action_0_5': '+20% 额外行动伤害',
  'action_0_6': '+5% 行动伤害提升',
  'action_0_7': '+5% 行动造成双倍伤害的概率',
  'action_0_8': '+5% 行动造成双倍伤害的概率 · +5% 行动伤害提升 · +5% 行动速度提升',
  'action_0_9': '+5% 行动伤害提升',
  'action_0_10': '+5% 行动造成双倍伤害的概率',
  'action_0_11': '行动命中有20%额外概率无视所有敌方伤害减免',
  'action_0_12': '+10% 额外行动伤害 · 行动速度降低6%',
  'action_0_13': '+10% 额外行动伤害 · +20% 额外行动魔力消耗',
  'action_0_14': '+15% 行动造成双倍伤害的概率提升',
  'action_0_15': '+10% 额外行动伤害',

  'action_1_0': '+4% 行动速度提升',
  'action_1_1': '+3% 行动重复施放概率提升',
  'action_1_2': '+10% 行动速度提升',
  'action_1_3': '+4% 行动速度提升',
  'action_1_4': '+3% 行动重复施放概率提升',
  'action_1_5': '+20% 额外行动速度',
  'action_1_6': '+4% 行动速度提升',
  'action_1_7': '+3% 行动重复施放概率提升',
  'action_1_8': '+4% 行动速度提升 · +3% 行动重复施放概率提升 · +5% 行动伤害提升',
  'action_1_9': '+4% 行动速度提升',
  'action_1_10': '+3% 行动重复施放概率提升',
  'action_1_11': '重复行动时，第二次初始命中必定触发苦难效果',
  'action_1_12': '+10% 额外行动速度 · 行动伤害降低10%',
  'action_1_13': '+5% 行动重复施放概率提升',
  'action_1_14': '双重行动重新掷骰一次以判断是否再次双重行动',
  'action_1_15': '不再有双重行动；双重行动概率转化为双倍伤害概率',

  'action_2_0': '行动有+2%概率触发入定',
  'action_2_1': '入定中的行动：+5%概率额外瞄准一个敌人 · +5%伤害提升 · +5%行动速度提升',
  'action_2_2': '行动有+5%概率触发入定',
  'action_2_3': '行动有+2%概率触发入定',
  'action_2_4': '入定中的行动：+5%概率额外瞄准一个敌人 · +5%伤害提升 · +5%行动速度提升',
  'action_2_5': '行动有+3%概率触发入定 · 入定中的行动：+8%概率额外瞄准一个敌人 · +8%伤害提升 · +8%行动速度提升',
  'action_2_12': '入定可与自身叠加一次 · 入定持续时间减半',
  'action_2_13': '行动有+5%概率触发入定',

  'action_3_0': '+10% 行动魔力消耗降低',
  'action_3_1': '+10% 行动免费施放概率',
  'action_3_2': '行动消耗魔力随机降低0–33%（每次行动独立随机）',
  'action_3_3': '+10% 行动魔力消耗降低',
  'action_3_4': '+10% 行动免费施放概率',
  'action_3_5': '+10% 行动魔力消耗降低 · +10% 行动免费施放概率 · 重复行动忽略魔力需求',
  'action_3_12': '此天赋树的魔力消耗降低效果改为增加魔力消耗 · 免费施放概率变为双倍消耗概率',
  'action_3_13': '行动魔力消耗降低30%',

  'criticalHit_0_0': '+10% 暴击伤害提升',
  'criticalHit_0_1': '+10% 暴击伤害提升',
  'criticalHit_0_2': '+20% 暴击伤害提升 · +10% 暴击概率提升',
  'criticalHit_0_3': '+10% 暴击伤害提升',
  'criticalHit_0_4': '+10% 暴击伤害提升',
  'criticalHit_0_5': '暴击有+20%额外概率无视所有敌方伤害减免',
  'criticalHit_0_6': '+10% 暴击伤害提升',
  'criticalHit_0_7': '+10% 暴击伤害提升',
  'criticalHit_0_8': '+20% 暴击伤害提升 · +10% 暴击概率提升',
  'criticalHit_0_9': '+10% 暴击伤害提升',
  'criticalHit_0_10': '+10% 暴击伤害提升',
  'criticalHit_0_11': '+20% 额外暴击伤害',
  'criticalHit_0_12': '+10% 额外暴击伤害',
  'criticalHit_0_13': '+10% 暴击无视所有敌方伤害减免的概率',
  'criticalHit_0_14': '此天赋树的暴击伤害加成应用于暴击的苦难伤害，而非直接命中',
  'criticalHit_0_15': '当暴击同时触发双倍伤害时，双倍伤害变为三倍伤害',

  'criticalHit_1_0': '+10% 暴击概率提升',
  'criticalHit_1_1': '+10% 暴击概率提升',
  'criticalHit_1_2': '+20% 暴击概率提升 · +10% 暴击伤害提升',
  'criticalHit_1_3': '+10% 暴击概率提升',
  'criticalHit_1_4': '+10% 暴击概率提升',
  'criticalHit_1_5': '+3% 行动基础暴击率',
  'criticalHit_1_6': '+10% 暴击概率提升',
  'criticalHit_1_7': '+10% 暴击概率提升',
  'criticalHit_1_8': '+20% 暴击概率提升 · +10% 暴击伤害提升',
  'criticalHit_1_9': '+10% 暴击概率提升',
  'criticalHit_1_10': '+10% 暴击概率提升',
  'criticalHit_1_11': '+20% 额外暴击概率',
  'criticalHit_1_12': '+2% 行动基础暴击率',
  'criticalHit_1_13': '+10% 额外暴击概率',
  'criticalHit_1_14': '暴击必定施加一个苦难效果 · 暴击不造成额外伤害',
  'criticalHit_1_15': '+20% 额外暴击概率（对含有任意苦难效果的敌人）',

  'physical_0_0': '+5% 物理伤害提升',
  'physical_0_1': '+3% 物理行动速度提升',
  'physical_0_2': '+5% 物理伤害提升 · 物理行动有+5%概率施加流血',
  'physical_0_3': '+5% 物理伤害提升',
  'physical_0_4': '+3% 物理行动速度提升',
  'physical_0_5': '+10% 额外物理伤害',
  'physical_0_6': '+5% 物理伤害提升',
  'physical_0_7': '+3% 物理行动速度提升',
  'physical_0_8': '+12% 物理伤害提升',
  'physical_0_9': '+5% 物理伤害提升',
  'physical_0_10': '+3% 物理行动速度提升',
  'physical_0_11': '流血中的敌人承受+10%额外物理伤害',

  'physical_1_0': '物理行动有+5%概率施加流血',
  'physical_1_1': '+15% 流血伤害提升',
  'physical_1_2': '+30% 流血伤害提升 · +10% 流血持续时间提升',
  'physical_1_3': '物理行动有+5%概率施加流血',
  'physical_1_4': '+15% 流血伤害提升',
  'physical_1_5': '+30% 额外流血伤害',
  'physical_1_6': '物理行动有+5%概率施加流血',
  'physical_1_7': '+15% 流血伤害提升',
  'physical_1_8': '+60% 流血伤害提升',
  'physical_1_9': '物理行动有+5%概率施加流血',
  'physical_1_10': '+15% 流血伤害提升',
  'physical_1_11': '流血无视敌人物理抗性',
  'physical_1_12': '+30% 额外流血伤害 · 流血持续时间减半',
  'physical_1_13': '流血持续时间翻倍 · 流血伤害降低30%',
  'physical_1_14': '流血伤害翻倍 · 命中不造成伤害',
  'physical_1_15': '+10% 额外流血伤害',

  'physical_2_0': '物理行动有+5%概率永久降低敌人物理与腐烂抗性1%',
  'physical_2_1': '+5% 物理伤害提升',
  'physical_2_2': '物理行动有+7%概率永久降低敌人物理与腐烂抗性1% · +3% 物理行动速度提升',
  'physical_2_3': '物理行动有+5%概率永久降低敌人物理与腐烂抗性1%',
  'physical_2_4': '+5% 物理伤害提升',
  'physical_2_5': '物理与腐烂抗性为0%的敌人行动速度与移动速度降低20%',

  'physical_3_0': '+5% 施加流血时触发嗜血的概率提升',
  'physical_3_1': '嗜血状态提供+5%物理行动速度提升',
  'physical_3_2': '嗜血状态提供+5%物理行动速度提升和+12%物理伤害提升 · 嗜血状态下的物理行动有+10%概率造成流血',
  'physical_3_3': '+5% 施加流血时触发嗜血的概率提升',
  'physical_3_4': '嗜血状态提供+5%物理行动速度提升',
  'physical_3_5': '嗜血状态提供+5%物理行动速度提升和+12%物理伤害提升 · +25% 嗜血持续时间提升',

  'fire_0_0': '+5% 火焰伤害提升',
  'fire_0_1': '+3% 火焰行动速度提升',
  'fire_0_2': '+5% 火焰伤害提升 · 火焰行动有+5%概率施加燃烧',
  'fire_0_3': '+5% 火焰伤害提升',
  'fire_0_4': '+3% 火焰行动速度提升',
  'fire_0_5': '+10% 额外火焰伤害',
  'fire_0_6': '+5% 火焰伤害提升',
  'fire_0_7': '+3% 火焰行动速度提升',
  'fire_0_8': '+12% 火焰伤害提升',
  'fire_0_9': '+5% 火焰伤害提升',
  'fire_0_10': '+3% 火焰行动速度提升',
  'fire_0_11': '燃烧中的敌人火焰抗性降低20%',

  'fire_1_0': '火焰行动有+5%概率施加燃烧',
  'fire_1_1': '+15% 燃烧伤害提升',
  'fire_1_2': '+30% 燃烧伤害提升 · +10% 燃烧持续时间提升',
  'fire_1_3': '火焰行动有+5%概率施加燃烧',
  'fire_1_4': '+15% 燃烧伤害提升',
  'fire_1_5': '+30% 额外燃烧伤害',
  'fire_1_6': '火焰行动有+5%概率施加燃烧',
  'fire_1_7': '+15% 燃烧伤害提升',
  'fire_1_8': '燃烧中的敌人承受来自所有来源+30%的伤害提升',
  'fire_1_9': '火焰行动有+5%概率施加燃烧',
  'fire_1_10': '+15% 燃烧伤害提升',
  'fire_1_11': '燃烧中的敌人将其50%的燃烧伤害扩散至附近未燃烧的敌人',
  'fire_1_12': '+30% 额外燃烧伤害 · 燃烧持续时间减半',
  'fire_1_13': '燃烧持续时间翻倍 · 燃烧伤害降低30%',
  'fire_1_14': '燃烧伤害翻倍 · 命中不造成伤害',
  'fire_1_15': '+10% 额外燃烧伤害',

  'fire_2_0': '火焰行动有+5%概率制造燃烧地面',
  'fire_2_1': '+45% 燃烧地面伤害提升',
  'fire_2_2': '+90% 燃烧地面伤害提升 · +30% 燃烧地面持续时间提升',
  'fire_2_3': '火焰行动有+5%概率制造燃烧地面',
  'fire_2_4': '+45% 燃烧地面伤害提升',
  'fire_2_5': '燃烧地面使敌人移动速度和行动速度降低20% · +30% 额外燃烧地面伤害',

  'fire_3_0': '火焰行动有+2%概率触发自燃',
  'fire_3_1': '自燃中：+5%火焰伤害提升 · +5%燃烧概率提升',
  'fire_3_2': '自燃的自身燃烧伤害减半（×0.5）',
  'fire_3_3': '火焰行动有+2%概率触发自燃',
  'fire_3_4': '自燃中：+5%火焰伤害提升 · +5%燃烧概率提升',
  'fire_3_5': '火焰行动有+5%概率触发自燃 · 自燃中：+10%火焰伤害提升 · +10%燃烧概率提升 · 自燃的自身燃烧伤害减半（×0.5）',

  'lightning_0_0': '+5% 闪电伤害提升',
  'lightning_0_1': '+3% 闪电行动速度提升',
  'lightning_0_2': '+5% 闪电伤害提升 · 闪电行动有+5%概率触电',
  'lightning_0_3': '+5% 闪电伤害提升',
  'lightning_0_4': '+3% 闪电行动速度提升',
  'lightning_0_5': '+10% 额外闪电伤害',
  'lightning_0_6': '+5% 闪电伤害提升',
  'lightning_0_7': '+3% 闪电行动速度提升',
  'lightning_0_8': '+12% 闪电伤害提升',
  'lightning_0_9': '+5% 闪电伤害提升',
  'lightning_0_10': '+3% 闪电行动速度提升',
  'lightning_0_11': '+10% 额外闪电伤害 · +5% 额外闪电行动速度',

  'lightning_1_0': '闪电行动有+5%概率触电',
  'lightning_1_1': '+3% 触电伤害承受提升',
  'lightning_1_2': '+5% 触电伤害承受提升 · +10% 触电持续时间提升',
  'lightning_1_3': '闪电行动有+5%概率触电',
  'lightning_1_4': '+3% 触电伤害承受提升',
  'lightning_1_5': '+8% 触电伤害承受提升 · +20% 触电持续时间提升',
  'lightning_1_6': '闪电行动有+5%概率触电',
  'lightning_1_7': '+3% 触电伤害承受提升',
  'lightning_1_8': '闪电行动有+15%概率触电',
  'lightning_1_9': '闪电行动有+5%概率触电',
  'lightning_1_10': '+3% 触电伤害承受提升',
  'lightning_1_11': '触电中的敌人移动速度和行动速度根据触电伤害承受值降低',
  'lightning_1_12': '+5% 触电伤害承受提升 · 触电持续时间降低10%',
  'lightning_1_13': '触电持续时间额外延长20%',
  'lightning_1_14': '闪电行动有+5%额外概率从触电敌人处跳跃',
  'lightning_1_15': '+5% 触电伤害承受提升',

  'lightning_2_0': '闪电行动有+20%概率跳跃至额外一个敌人',
  'lightning_2_1': '+10% 跳跃伤害惩罚降低',
  'lightning_2_2': '闪电行动有+30%概率跳跃至额外一个敌人 · +15%跳跃伤害惩罚降低',
  'lightning_2_3': '闪电行动有+20%概率跳跃至额外一个敌人',
  'lightning_2_4': '+10% 跳跃伤害惩罚降低',
  'lightning_2_5': '成功跳跃后重新掷骰判断是否再次跳跃（无限链式）· +30% 跳跃范围提升',

  'lightning_3_0': '闪电行动有+5%额外概率触发感电',
  'lightning_3_1': '感电中行动速度+5%提升',
  'lightning_3_2': '+25% 感电持续时间提升 · 感电中行动速度+5%提升',
  'lightning_3_3': '闪电行动有+5%额外概率触发感电',
  'lightning_3_4': '感电中行动速度+5%提升',
  'lightning_3_5': '感电中来自所有来源的伤害承受降低5%',

  'area_0_0': '+5% 范围伤害提升',
  'area_0_1': '+5% 范围造成双倍伤害的概率',
  'area_0_2': '+12% 范围伤害提升',
  'area_0_3': '+5% 范围伤害提升',
  'area_0_4': '+5% 范围造成双倍伤害的概率',
  'area_0_5': '+20% 额外范围伤害',
  'area_0_6': '+5% 范围伤害提升',
  'area_0_7': '+5% 范围造成双倍伤害的概率',
  'area_0_8': '+5% 范围造成双倍伤害的概率 · +5% 范围伤害提升 · +5% 范围大小提升',
  'area_0_9': '+5% 范围伤害提升',
  'area_0_10': '+5% 范围造成双倍伤害的概率',
  'area_0_11': '+30% 额外范围伤害 · 范围行动速度降低15%',

  'area_1_0': '+5% 范围行动半径提升',
  'area_1_1': '+5% 范围伤害提升',
  'area_1_2': '+12% 范围行动半径提升',
  'area_1_3': '+5% 范围行动半径提升',
  'area_1_4': '+5% 范围伤害提升',
  'area_1_5': '+15% 额外范围行动半径',
  'area_1_6': '+5% 范围行动半径提升',
  'area_1_7': '+5% 范围伤害提升',
  'area_1_8': '+8% 范围行动半径提升 · +5% 范围伤害提升',
  'area_1_9': '+5% 范围行动半径提升',
  'area_1_10': '+5% 范围伤害提升',
  'area_1_11': '+10% 额外范围行动半径 · +10% 额外范围伤害 · 范围行动速度降低10%',

  'area_2_0': '范围行动有+5%额外概率触发余震',
  'area_2_1': '余震伤害+5%提升',
  'area_2_2': '范围行动有+8%额外概率触发余震 · 余震范围半径+8%提升',
  'area_2_3': '范围行动有+5%额外概率触发余震',
  'area_2_4': '余震伤害+5%提升',
  'area_2_5': '范围行动有+7%额外概率触发余震 · 余震范围半径+7%提升 · 余震伤害+7%提升',

  'area_3_0': '范围命中有+10%概率击退目标',
  'area_3_1': '被击退的敌人移动速度降低10%，持续2秒',
  'area_3_2': '范围命中有+15%概率击退目标 · +15% 范围伤害提升',
  'area_3_3': '范围命中有+10%概率击退目标',
  'area_3_4': '被击退的敌人移动速度降低10%，持续2秒',
  'area_3_5': '+30% 额外击退范围 · 被击退的敌人造成伤害降低10%，持续2秒',

  'projectile_0_0': '+5% 投射物伤害提升',
  'projectile_0_1': '+5% 命中额外目标的概率',
  'projectile_0_2': '+12% 投射物伤害提升',
  'projectile_0_3': '+5% 投射物伤害提升',
  'projectile_0_4': '+5% 命中额外目标的概率',
  'projectile_0_5': '+20% 额外投射物伤害',
  'projectile_0_6': '+5% 投射物伤害提升',
  'projectile_0_7': '+5% 命中额外目标的概率',
  'projectile_0_8': '+5% 命中额外目标的概率 · +5% 投射物伤害提升 · +5% 行动速度提升',
  'projectile_0_9': '+5% 投射物伤害提升',
  'projectile_0_10': '+5% 命中额外目标的概率',
  'projectile_0_11': '+20% 造成双倍伤害的概率 · +10% 投射物射程提升',

  'projectile_1_0': '+5% 以50%伤害发射额外投射物的概率',
  'projectile_1_1': '+5% 额外投射物伤害提升',
  'projectile_1_2': '+7% 发射额外投射物的概率 · +7% 额外投射物伤害提升',
  'projectile_1_3': '+5% 发射额外投射物的概率',
  'projectile_1_4': '+5% 额外投射物伤害提升',
  'projectile_1_5': '+15% 发射额外投射物的概率',
  'projectile_1_6': '+5% 发射额外投射物的概率',
  'projectile_1_7': '+5% 额外投射物伤害提升',
  'projectile_1_8': '+7% 发射额外投射物的概率 · +7% 额外投射物伤害提升',
  'projectile_1_9': '+5% 发射额外投射物的概率',
  'projectile_1_10': '+5% 额外投射物伤害提升',
  'projectile_1_11': '当额外投射物触发时，再次掷骰判断是否触发第二枚额外投射物',

  'projectile_2_0': '+5% 投射物射程提升',
  'projectile_2_1': '+5% 投射物伤害提升',
  'projectile_2_2': '+12% 投射物射程提升',
  'projectile_2_3': '+5% 投射物射程提升',
  'projectile_2_4': '+5% 投射物伤害提升',
  'projectile_2_5': '每1射程单位+5%投射物伤害提升（射程1时最低5%）',

  'projectile_3_0': '投射物命中有+10%概率击退目标',
  'projectile_3_1': '被击退的敌人移动速度降低10%，持续2秒',
  'projectile_3_2': '投射物命中有+15%概率击退目标 · +15% 投射物伤害提升',
  'projectile_3_3': '投射物命中有+10%概率击退目标',
  'projectile_3_4': '被击退的敌人移动速度降低10%，持续2秒',
  'projectile_3_5': '+30% 额外击退范围 · 被击退的敌人造成伤害降低10%，持续2秒',

  'strike_0_0': '+5% 打击伤害提升',
  'strike_0_1': '+5% 打击造成双倍伤害的概率',
  'strike_0_2': '+12% 打击伤害提升',
  'strike_0_3': '+5% 打击伤害提升',
  'strike_0_4': '+5% 打击造成双倍伤害的概率',
  'strike_0_5': '+20% 额外打击伤害',
  'strike_0_6': '+5% 打击伤害提升',
  'strike_0_7': '+5% 打击造成双倍伤害的概率',
  'strike_0_8': '+5% 打击造成双倍伤害的概率 · +5% 打击伤害提升 · +5% 行动速度提升',
  'strike_0_9': '+5% 打击伤害提升',
  'strike_0_10': '+5% 打击造成双倍伤害的概率',
  'strike_0_11': '打击有+20%额外概率触发苦难效果',

  'strike_1_0': '打击有+5%额外概率触发狂热',
  'strike_1_1': '狂热每层给予+1%伤害和行动速度提升',
  'strike_1_2': '打击有+5%额外概率触发狂热 · 狂热固定给予+10%伤害和行动速度提升',
  'strike_1_3': '打击有+5%额外概率触发狂热',
  'strike_1_4': '狂热每层给予+1%伤害和行动速度提升',
  'strike_1_5': '狂热每层有+1%额外概率触发苦难效果',
  'strike_1_6': '打击有+5%额外概率触发狂热',
  'strike_1_7': '狂热每层给予+1%伤害和行动速度提升',
  'strike_1_8': '打击有+5%额外概率触发狂热 · 狂热持续时间+20%提升 · 狂热每层给予+1%伤害和行动速度提升',
  'strike_1_9': '打击有+5%额外概率触发狂热',
  'strike_1_10': '狂热每层给予+1%伤害和行动速度提升',
  'strike_1_11': '狂热最大层数额外增加10层',

  'strike_2_0': '+5% 打击范围提升',
  'strike_2_1': '+3% 打击行动速度提升',
  'strike_2_2': '+5% 打击范围提升 · +5% 打击伤害提升',
  'strike_2_3': '+5% 打击范围提升',
  'strike_2_4': '+3% 打击行动速度提升',
  'strike_2_5': '+10% 额外打击范围 · +5% 额外打击行动速度 · 打击有 10% 更高的溅射几率',

  'strike_3_0': '+8% 打击行动瞄准额外敌人的概率提升',
  'strike_3_1': '+3% 打击行动速度提升',
  'strike_3_2': '+15% 打击行动瞄准额外敌人的概率提升',
  'strike_3_3': '+8% 打击行动瞄准额外敌人的概率提升',
  'strike_3_4': '+3% 打击行动速度提升',
  'strike_3_5': '+20% 额外打击行动瞄准额外敌人的概率 · 打击有 10% 更高的溅射几率',

  'life_0_0': '+5% 最大生命提升',
  'life_0_1': '+5% 物理与腐烂抗性',
  'life_0_2': '+12% 最大生命提升',
  'life_0_3': '+5% 最大生命提升',
  'life_0_4': '+5% 元素抗性',
  'life_0_5': '+30% 额外最大生命',
  'life_0_6': '+5% 最大生命提升',
  'life_0_7': '+5% 物理与腐烂抗性',
  'life_0_8': '+7% 物理与腐烂抗性 · +7% 元素抗性',
  'life_0_9': '+5% 最大生命提升',
  'life_0_10': '+5% 元素抗性',
  'life_0_11': '+30% 额外最大生命',
  'life_0_12': '生命回复的提升和额外效果同样应用于最大生命 · 无法偷取生命',
  'life_0_13': '+20% 额外最大生命 · 行动伤害降低10%',
  'life_0_14': '每点生命等级+1%最大生命提升',
  'life_0_15': '+10% 额外最大生命',

  'life_1_0': '+5% 物理与腐烂抗性',
  'life_1_1': '+5% 元素抗性',
  'life_1_2': '+7% 物理与腐烂抗性 · +7% 元素抗性',
  'life_1_3': '+5% 物理与腐烂抗性',
  'life_1_4': '+5% 元素抗性',
  'life_1_5': '抗性吸收伤害的5%作为生命回复',
  'life_1_6': '+5% 物理与腐烂抗性',
  'life_1_7': '+5% 元素抗性',
  'life_1_8': '+7% 物理与腐烂抗性 · +7% 元素抗性',
  'life_1_9': '+5% 物理与腐烂抗性',
  'life_1_10': '+5% 元素抗性',
  'life_1_11': '施加于你的抗性降低效果效率降低50%',
  'life_1_12': '+7% 物理与腐烂抗性 · -7% 元素抗性',
  'life_1_13': '+7% 元素抗性 · -7% 物理与腐烂抗性',
  'life_1_14': '+7% 全抗性 · 最大生命降低10%',
  'life_1_15': '+15% 全抗性 · 无法偷取生命',

  'life_2_0': '+5% 生命回复提升',
  'life_2_1': '+5% 生命回复提升',
  'life_2_2': '+12% 生命回复提升',
  'life_2_3': '+5% 生命回复提升',
  'life_2_4': '+5% 生命回复提升',
  'life_2_5': '每秒回复+0.3%最大生命',
  'life_2_12': '生命回复翻倍 · 每次命中偷取的最大生命降低30%',
  'life_2_13': '生命回复翻倍 · 全抗性-5%',

  'life_3_0': '行动命中伤害的+0.5%作为生命偷取',
  'life_3_1': '+5% 生命偷取提升',
  'life_3_2': '+10% 生命偷取上限提升',
  'life_3_3': '行动命中伤害的+0.5%作为生命偷取',
  'life_3_4': '+5% 生命偷取提升',
  'life_3_5': '生命偷取有1%概率触发饕餮狂热',
  'life_3_12': '+30% 额外每次命中最大生命偷取 · 无法回复生命',
  'life_3_13': '可从苦难伤害中偷取生命',

  'mana_0_0': '+5% 最大魔力提升',
  'mana_0_1': '+2% 最大魔力提升 · +2% 魔力回复提升',
  'mana_0_2': '+12% 最大魔力提升',
  'mana_0_3': '+5% 最大魔力提升',
  'mana_0_4': '+2% 最大魔力提升 · +2% 魔力回复提升',
  'mana_0_5': '+20% 额外最大魔力',
  'mana_0_6': '+5% 最大魔力提升',
  'mana_0_7': '+2% 最大魔力提升 · +2% 魔力回复提升',
  'mana_0_8': '+15% 最大魔力提升 · +5% 魔力回复提升 · +5% 行动速度提升',
  'mana_0_9': '+5% 最大魔力提升',
  'mana_0_10': '+2% 最大魔力提升 · +2% 魔力回复提升',
  'mana_0_11': '+20% 额外最大魔力 · +3% 额外最大生命',

  'mana_1_0': '魔力护盾吸收+5%的命中伤害',
  'mana_1_1': '魔力护盾转换消耗降低5%',
  'mana_1_2': '魔力护盾吸收+10%的命中伤害',
  'mana_1_3': '魔力护盾吸收+5%的命中伤害',
  'mana_1_4': '魔力护盾转换消耗降低5%',
  'mana_1_5': '魔力护盾现在拦截所有伤害来源',
  'mana_1_6': '魔力护盾吸收+5%的命中伤害',
  'mana_1_7': '魔力护盾转换消耗降低5%',
  'mana_1_8': '魔力护盾吸收+10%的命中伤害',
  'mana_1_9': '魔力护盾吸收+5%的命中伤害',
  'mana_1_10': '魔力护盾转换消耗降低5%',
  'mana_1_11': '你的抗性降低魔力护盾的转换消耗',

  'mana_2_0': '+5% 魔力回复提升',
  'mana_2_1': '+5% 魔力回复提升',
  'mana_2_2': '+12% 魔力回复提升',
  'mana_2_3': '+5% 魔力回复提升',
  'mana_2_4': '+5% 魔力回复提升',
  'mana_2_5': '+10% 行动回复魔力而非消耗魔力的概率',

  'mana_3_0': '行动命中伤害的+0.5%作为魔力偷取',
  'mana_3_1': '+5% 魔力偷取提升',
  'mana_3_2': '+10% 魔力偷取上限提升',
  'mana_3_3': '行动命中伤害的+0.5%作为魔力偷取',
  'mana_3_4': '+5% 魔力偷取提升',
  'mana_3_5': '魔力偷取有1%概率触发饕餮狂热',

  'enemy_0_0': '+50% 额外刷新一个敌人的概率',
  'enemy_0_1': '+25% 额外刷新2个敌人的概率',
  'enemy_0_2': '+1个保底敌人刷新',
  'enemy_0_3': '+50% 额外刷新一个敌人的概率',
  'enemy_0_4': '+25% 额外刷新2个敌人的概率',
  'enemy_0_5': '+2个保底敌人刷新 · 至少一个敌人刷新为强力级',
  'enemy_0_6': '+50% 额外刷新一个敌人的概率',
  'enemy_0_7': '+25% 额外刷新2个敌人的概率',
  'enemy_0_8': '+1个保底敌人刷新',
  'enemy_0_9': '+50% 额外刷新一个敌人的概率',
  'enemy_0_10': '+25% 额外刷新2个敌人的概率',
  'enemy_0_11': '+2个保底敌人刷新 · 至少一个敌人刷新为精英级',

  'enemy_1_0': '+5% 敌人成为强力级的概率',
  'enemy_1_1': '+10% 强力敌人成为精英级的概率',
  'enemy_1_2': '+12% 敌人成为强力级的概率',
  'enemy_1_3': '+5% 敌人成为强力级的概率',
  'enemy_1_4': '+10% 强力敌人成为精英级的概率',
  'enemy_1_5': '至少一个敌人刷新为强力级 · 至少一个敌人刷新为精英级',
  'enemy_1_6': '+5% 敌人成为强力级的概率',
  'enemy_1_7': '+10% 强力敌人成为精英级的概率',
  'enemy_1_8': '+12% 敌人成为强力级的概率',
  'enemy_1_9': '+5% 敌人成为强力级的概率',
  'enemy_1_10': '+10% 强力敌人成为精英级的概率',
  'enemy_1_11': '+20% 敌人成为强力级的概率 · +20% 强力敌人成为精英级的概率 · +1个保底敌人刷新',

  'enemy_2_0': '+5% 精英敌人成为冠军的概率',
  'enemy_2_1': '+5% 敌人成为强力级的概率 · +5% 强力敌人成为精英级的概率',
  'enemy_2_2': '+5% 敌人成为强力级的概率 · +5% 强力敌人成为精英级的概率 · +5% 精英敌人成为冠军的概率',
  'enemy_2_3': '+5% 精英敌人成为冠军的概率',
  'enemy_2_4': '+5% 敌人成为强力级的概率 · +5% 强力敌人成为精英级的概率',
  'enemy_2_5': '+1% 冠军敌人成为Boss的概率',

  'enemy_3_0': '+10% 击杀时在下一波次刷新额外敌人的概率',
  'enemy_3_1': '+10% 击杀时在下一波次刷新额外敌人的概率',
  'enemy_3_2': '刷新敌人数量额外增加15%',
  'enemy_3_3': '+10% 击杀时在下一波次刷新额外敌人的概率',
  'enemy_3_4': '+10% 击杀时在下一波次刷新额外敌人的概率',
  'enemy_3_5': '刷新敌人数量额外增加20%',

  'movement_0_0': '+5% 移动速度提升',
  'movement_0_1': '+5% 移动速度提升',
  'movement_0_2': '+12% 移动速度提升',
  'movement_0_3': '+5% 移动速度提升',
  'movement_0_4': '+5% 移动速度提升',
  'movement_0_5': '+15% 额外移动速度',
  'movement_0_6': '+5% 移动速度提升',
  'movement_0_7': '+5% 移动速度提升',
  'movement_0_8': '+12% 移动速度提升',
  'movement_0_9': '+5% 移动速度提升',
  'movement_0_10': '+5% 移动速度提升',
  'movement_0_11': '施加于你的移动减速效果效率降低50%',
  'movement_0_12': '移动后的第一次行动造成额外10%伤害',
  'movement_0_13': '每次连续未移动的行动+1%行动伤害，最多+10%',
  'movement_0_14': '免疫所有移动减速效果',
  'movement_0_15': '+15% 额外移动速度',

  'movement_1_0': '+20% 每秒获得冲刺充能的概率',
  'movement_1_1': '+10% 冲刺距离提升',
  'movement_1_2': '+30% 每秒获得冲刺充能的概率 · +10% 冲刺距离提升',
  'movement_1_3': '+20% 每秒获得冲刺充能的概率',
  'movement_1_4': '+10% 冲刺距离提升',
  'movement_1_5': '+50% 每秒获得冲刺充能的概率',
  'movement_1_12': '冲刺可额外持有一个充能 · 冲刺距离降低20%',
  'movement_1_13': '冲刺总是尝试接近最近的敌人，无视行动范围',

  'movement_2_0': '当敌人在行动范围一半内时，使用25%移动速度进行风筝走位',
  'movement_2_1': '当敌人在行动范围一半内时，使用25%移动速度进行风筝走位',
  'movement_2_2': '风筝走位时全抗性+5',
  'movement_2_3': '当敌人在行动范围一半内时，使用25%移动速度进行风筝走位',
  'movement_2_4': '当敌人在行动范围一半内时，使用25%移动速度进行风筝走位',
  'movement_2_5': '冲刺可用于风筝走位远离敌人',
  'movement_2_12': '只要目标在射程内就持续风筝走位，后撤至行动射程的 90%',
  'movement_2_13': '风筝走位时行动速度+5%提升',

  'cold_0_0':  '+5% 冰冷伤害提升',
  'cold_0_1':  '+3% 冰冷行动速度提升',
  'cold_0_2':  '+5% 冰冷伤害提升 · +5% 霜冻施加概率提升',
  'cold_0_3':  '+5% 冰冷伤害提升',
  'cold_0_4':  '+3% 冰冷行动速度提升',
  'cold_0_5':  '10% 更多冰冷伤害',
  'cold_0_6':  '+5% 冰冷伤害提升',
  'cold_0_7':  '+3% 冰冷行动速度提升',
  'cold_0_8':  '+12% 冰冷伤害提升',
  'cold_0_9':  '+5% 冰冷伤害提升',
  'cold_0_10': '+3% 冰冷行动速度提升',
  'cold_0_11': '被霜冻的敌人受到非冰冷来源20%更多伤害',

  'cold_1_0':  '+5% 霜冻施加概率提升',
  'cold_1_1':  '+3% 霜冻减速提升',
  'cold_1_2':  '+5% 霜冻减速提升 · +10% 霜冻持续时间提升',
  'cold_1_3':  '+5% 霜冻施加概率提升',
  'cold_1_4':  '+3% 霜冻减速提升',
  'cold_1_5':  '+8% 霜冻减速提升 · +20% 霜冻持续时间提升',
  'cold_1_6':  '+5% 霜冻施加概率提升',
  'cold_1_7':  '+3% 霜冻减速提升',
  'cold_1_8':  '+15% 霜冻施加概率提升',
  'cold_1_9':  '+5% 霜冻施加概率提升',
  'cold_1_10': '+3% 霜冻减速提升',
  'cold_1_11': '霜冻减速效果提高15%',
  'cold_1_12': '+5% 霜冻减速提升 · 霜冻持续时间减少10%',
  'cold_1_13': '霜冻持续时间延长20%',
  'cold_1_14': '被霜冻的敌人造成10%更少伤害',
  'cold_1_15': '+5% 霜冻减速提升',

  'cold_2_0':  '霜冻状态下被击杀的敌人有+5%几率破碎',
  'cold_2_1':  '破碎伤害提高被破碎敌人最大生命的2%',
  'cold_2_2':  '霜冻状态下被击杀的敌人有+8%几率破碎 · +25% 破碎作用范围提升',
  'cold_2_3':  '霜冻状态下被击杀的敌人有+5%几率破碎',
  'cold_2_4':  '破碎伤害提高被破碎敌人最大生命的2%',
  'cold_2_5':  '霜冻状态下被击杀的敌人有+10%几率破碎 · 破碎伤害提高被破碎敌人最大生命的3%',

  'cold_3_0':  '冰甲获得一层所需的霜冻次数减少20',
  'cold_3_1':  '每层冰甲减少1%所受打击伤害',
  'cold_3_2':  '获得1层冰甲时有30%几率改为获得2层 · 冰甲层数消退速度减慢20%',
  'cold_3_3':  '冰甲获得一层所需的霜冻次数减少20',
  'cold_3_4':  '每层冰甲减少1%所受打击伤害',
  'cold_3_5':  '冰甲最大层数增加5',
}
